'use client';

import { cn } from '@core/utils';

import { AdBadge } from '@/app/_components/ads';
import { AD_UNIT_IDS } from '@/constants/ad';
import { AD_MOCK_DATA, AD_MOCK_MODE, isAdHidden, useAd } from '@/hooks/useAd';

export const PolicyAdCard = () => {
  const { containerRef, adState } = useAd(AD_UNIT_IDS.HOME_NATIVE_POLICY);

  if (isAdHidden(adState)) {
    return null;
  }

  return (
    <div
      ref={containerRef}
      className={cn(
        'group mr-8 flex min-h-180 w-220 shrink-0 cursor-pointer flex-col justify-between rounded-xlarge bg-Gray-white p-20',
        'transition-colors duration-200 ease-out hover:bg-Gray-25',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-B-500 focus-visible:ring-offset-2',
        'active:scale-[0.98]',
        adState === 'loading' && 'animate-pulse',
        adState === 'idle' && 'opacity-0',
      )}
    >
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-4">
          <AdBadge className="static shrink-0" />
        </div>
        <h3
          data-adrop-native="headline"
          className="mb-12 whitespace-pre-line font-600 text-Gray-900 transition-colors duration-200 typo-body4 group-hover:text-Gray-800"
        >
          {AD_MOCK_MODE && AD_MOCK_DATA.headline}
        </h3>
      </div>
      <div>
        <span
          data-adrop-native="body"
          className="whitespace-pre-line font-600 text-Gray-550 typo-caption1"
        >
          {AD_MOCK_MODE && AD_MOCK_DATA.body}
        </span>
      </div>
    </div>
  );
};
